import { useState } from 'react';
import { Upload } from 'antd';
import toast from 'react-hot-toast';
import { LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './invoiceform.module.scss';
import { uploadImageAndGetUrl } from '~/utils/firebase';

interface ISetValue {
  logoUrl: string;
  logo: Blob;
}

interface ILogoUploadProps {
  setValue({ logoUrl, logo }: ISetValue): void;
  preImageUrl?: string;
}

const LogoUpload = ({ setValue, preImageUrl }: ILogoUploadProps) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>(preImageUrl ?? '');

  const beforeUpload = (file: File) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      toast.error('You can only upload JPG/PNG file!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      toast.error('Image must be smaller than 5MB!');
    }
    return isJpgOrPng && isLt5M;
  };

  const handleUpload = async (file: File) => {
    setLoading(true);
    console.log('Uploading file...');

    // Upload to Firebase
    const { isSuccess, downloadLink } = await uploadImageAndGetUrl(file);
    console.log({ isSuccess, downloadLink });

    if (isSuccess) {
      setLoading(false);
      setImageUrl(downloadLink);
      setValue({
        logo: file,
        logoUrl: downloadLink,
      });
    } else {
      toast.error('Upload failed, please try again.');
      setLoading(false);
    }
  };

  const handleClearImage = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the upload
    setImageUrl('');
    setValue({
      logo: new Blob(),
      logoUrl: '',
    });
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : <div className={styles.logoText}>Your Logo</div>}
    </button>
  );

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="customAvatarUploader"
      showUploadList={false}
      beforeUpload={file => {
        if (beforeUpload(file)) {
          handleUpload(file); // Call manual upload function
        }
        return false; // Prevent default POST request
      }}
      customRequest={() => {}} // Prevent default POST request
    >
      {imageUrl ? (
        <div className={styles.logoImageContainer}>
          <img className="uploadPlaceImg" src={imageUrl} alt="avatar" style={{ width: '100%' }} />
          {loading && (
            <div className={styles.logoLoadingOverlay}>
              <LoadingOutlined />
            </div>
          )}
          <button
            type="button"
            onClick={handleClearImage}
            className={styles.logoClearButton}
          >
            <CloseOutlined />
          </button>
        </div>
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default LogoUpload;
